/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_ServiceInputs */

const vi_carrier_service = /** @type {(inputs: Carrier_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dịch vụ`)
};

/**

* @param {Carrier_ServiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_service = /** @type {((inputs?: Carrier_ServiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_ServiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_service(inputs)
});